/**
 * CloudSlides Predictive Search
 * Handles live search query and suggestions
 */
class PredictiveSearch {
  constructor() {
    this.input = document.querySelector('[data-predictive-search-input]');
    this.results = document.querySelector('[data-predictive-search-results]');
    this.modal = document.querySelector('[data-search-modal]');
    this.triggers = document.querySelectorAll('[data-search-trigger]');
    this.closeButtons = document.querySelectorAll('[data-search-close]');
    this.init();
  }

  init() {
    this.triggers.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });

    if (this.input) {
      let timeout;
      this.input.addEventListener('input', () => {
        clearTimeout(timeout);
        const query = this.input.value.trim();
        if (query.length < 2) {
          if (this.results) this.results.innerHTML = '';
          return;
        }
        timeout = setTimeout(() => this.search(query), 300);
      });
    }
  }

  open() {
    if (this.modal) {
      this.modal.classList.remove('hidden');
      this.input && this.input.focus();
    }
  }

  close() {
    if (this.modal) {
      this.modal.classList.add('hidden');
    }
  }

  async search(query) {
    try {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
      const data = await res.json();
      this.render(data.resources.results.products);
    } catch (e) {
      console.error(e);
    }
  }

  render(products) {
    if (!this.results) return;
    if (!products || products.length === 0) {
      this.results.innerHTML = '<p class="text-sm text-gray-500 py-4 text-center">Aucun modèle trouvé pour votre recherche.</p>';
      return;
    }
    this.results.innerHTML = products.map(p => `
      <a href="${p.url}" class="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors">
        <img src="${p.featured_image || ''}" alt="${p.title}" class="w-12 h-12 rounded object-cover" />
        <div>
          <h4 class="text-sm font-semibold text-gray-900">${p.title}</h4>
          <span class="text-sm text-sky-600 font-bold">${p.price}</span>
        </div>
      </a>
    `).join('');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new PredictiveSearch();
});
